"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _ = require('lodash');
module.exports = /*@ngInject*/function ($q, $resource, ConfigService, LokiService, MOBILE) {
  var _ConfigService$getCon = ConfigService.getConfig(),
    INSPECT_URL = _ConfigService$getCon.INSPECT_URL;
  var service = $resource("".concat(INSPECT_URL, "/api/checklist/:id"), {
    id: '@id'
  }, {
    update: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/checklist/:id")
    },
    _get: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/checklist/:id")
    },
    getUniqTags: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/checklist/find-uniq-tags"),
      isArray: 1
    },
    fetchShared: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/checklist/find/shared"),
      isArray: 1
    },
    find: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/checklist/find/all"),
      isArray: 1
    },
    findByProgram: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/checklist/program/:programId"),
      isArray: 1
    },
    upsert: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/update/:action")
    },
    upsertCategory: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/category")
    },
    deleteCategory: {
      method: 'DELETE',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/category")
    },
    upsertTag: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/tag")
    },
    deleteTag: {
      method: 'DELETE',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/tag")
    },
    createFinding: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/finding")
    },
    updateFinding: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/finding/:findingId")
    },
    deteleFinding: {
      method: 'DELETE',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/finding/:findingId")
    },
    createClassification: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/classification")
    },
    updateClassification: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/classification/:name")
    },
    deleteClassification: {
      method: 'DELETE',
      url: "".concat(INSPECT_URL, "/api/checklist/:id/classification/:name")
    }
  });
  service.get = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(options, cb) {
      var collection, result;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!MOBILE) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return LokiService.collection('checklist');
          case 3:
            collection = _context.sent;
            result = collection.findOne({
              _id: options.id
            });
            return _context.abrupt("return", cb ? cb(result) : Promise.resolve(result));
          case 6:
            return _context.abrupt("return", service._get(options, cb).$promise);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  service.filterChecklist = function (checklist, filters) {
    var filterChecklist = _.cloneDeep(checklist);
    if (filters && filters.length) {
      _.remove(filterChecklist.findings, function (finding) {
        _.remove(finding.categories, function (category) {
          return _.intersection(category.filters, filters).length === 0;
        });
        return finding.categories.length === 0;
      });
    }
    return filterChecklist;
  };
  service.filterFindingsByCategory = function (findings, categoryName) {
    return _.filter(findings, function (finding) {
      return _.some(finding.categories, function (category) {
        return category.name === categoryName;
      });
    });
  };
  return service;
};